import Component from 'flarum/common/Component';
import Hero from './Hero';
import ServerStatus from './ServerStatus';
import ProfilePanel from './ProfilePanel';
import CommunityPanel from './CommunityPanel';
import BrandMark from './BrandMark';
import app from 'flarum/forum/app';
import Shoutbox from './Shoutbox';
import ForumDirectory from './ForumDirectory';
import PortalWidgets, { RoleLegend, TeamOnlineWidget } from './PortalWidgets';
import NovaQuickNavigation from './NovaQuickNavigation';
import HomeAnnouncements from './HomeAnnouncements';
import HomeEffects from './HomeEffects';
import HomeDiscussionFeed from './HomeDiscussionFeed';
export default class HomeLayout extends Component {
  view() {
    const showHero = String(app.forum.attribute('novatruckShowHero') ?? '1') !== '0';
    const showProfile = String(app.forum.attribute('novatruckShowProfileCard') ?? '1') !== '0';
    return m("div", {
      className: "NtHome"
    }, m(HomeEffects, null), showHero && m(Hero, null), m(ServerStatus, null), m(HomeAnnouncements, null), m(NovaQuickNavigation, null), m("div", {
      className: `container NtHome-grid ${showProfile ? '' : 'NtHome-grid--single'}`
    }, m("main", {
      className: "NtHome-main"
    }, m("section", {
      className: "NtHome-live",
      "aria-label": "Aktywno\u015B\u0107 spo\u0142eczno\u015Bci"
    }, m("div", {
      className: "NtHome-chat"
    }, m(Shoutbox, null)), m("div", {
      className: "NtHome-feed"
    }, m(HomeDiscussionFeed, null))), m(ForumDirectory, null)), showProfile && m("aside", {
      className: "NtHome-aside"
    }, m(ProfilePanel, null), m(PortalWidgets, null), m(TeamOnlineWidget, null), m(CommunityPanel, null))), m(RoleLegend, null), m("footer", {
      className: "NtFooter"
    }, m("div", {
      className: "container NtFooter-inner"
    }, m("div", {
      className: "NtFooter-brand"
    }, m(BrandMark, null), m("strong", null, "NovaTruck & RP")), m("nav", {
      "aria-label": "Stopka"
    }, m("a", {
      href: "/polityka-prywatnosci"
    }, "Polityka prywatno\u015Bci"), m("a", {
      href: "/regulamin"
    }, "Regulamin"), m("a", {
      href: "/kontakt"
    }, "Kontakt")), m("small", null, "\xA9 ", new Date().getFullYear(), " NovaTruck & RP. Wszelkie prawa zastrze\u017Cone."))));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/HomeLayout', HomeLayout);